export const Image = {
  logo: require('./images/logo.png'),
  successIcon: require('./images/icon-acknowledgement.png'),
  tokenIcon: require('./images/icon-token.png'),
  failIcon: require('./images/icon-fail.png'),
  emptyIcon: require('./images/icon-empty.png'),
  landingPopUp: require('./images/pop_up.jpg'),
  mobileLogo: require('./images/mobile_logo.png'),
};
